<template>
  <ValidationProvider
    :rules="computedValidations"
    v-slot="{ errors }"
    class="input-group-lg"
    v-if="toDisplay"
    :name="field.name"
    :vid="field.name"
  >
    <span
      class="ml-2"
      :class="field.label_class"
      v-if="field.show_label"
    >
      {{ field.label }}
    </span>
    <input
      :type="field.type" :id="idPrefix + '-' + field.name"
      class="form-control input-field mb-0"
      :class="{ 'box-alert': errors[0] }"
      v-model="model[field.name]" :style="field.only_uppercase ? 'text-transform: uppercase;' : ''"
      :name="field.name" :placeholder="field.placeholder" :readonly="field.readonly"
      :value="model[field.name]" @input="$emit(field.name, $event.target.value)"
      v-mask="field.mask"
      @keyup="updateValue"
      :disabled="isCopyAddressDisabled || field.disabled"
    />
    <small class="w-100 text-black-50" v-if="field.help_text">{{ field.help_text }}</small>
    <div class="validation-error" v-if="errors[0]">
      <span class="w-100 text-danger">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';

// Register password_min rule (idempotent)
extend('password_min', {
  validate: (value) => typeof value === 'string' && value.length >= 12,
  message: 'Password must be at least 12 characters',
});

export default {
  name: 'InputField',

  inheritAttrs: false,

  components: {
    ValidationProvider,
  },

  props: {
    idPrefix: {
      type: String,
      required: true,
    },

    field: {
      type: Object,
      required: true,
    },

    model: {
      type: Object,
      required: true,
    },

    isCopyAddress: Boolean,
    disablePasswordValidation: { type: Boolean, default: false },
  },

  data() {
    return {
      timeout: null,
      isCopyAddressDisabled: false,
    };
  },

  watch: {
    isCopyAddress() {
      if (this.field.copy_address !== undefined && this.isCopyAddress) {
        if (this.currentUser[this.field.copy_address] !== undefined) {
          this.model[this.field.name] = this.currentUser[this.field.copy_address];
        } else {
          this.model[this.field.name] = this.currentUser.extra_info[this.field.copy_address];
        }
        this.isCopyAddressDisabled = true;
      } else {
        this.isCopyAddressDisabled = false;
      }
    },

    fieldMapping() {},
  },

  computed: {
    currentUser() {
      return this.$store.state.users.currentUser;
    },

    toDisplay() {
      if (this.field.parent !== undefined && !this.field.mappings) {
        return this.field.parent_value.includes(this.model[this.field.parent]);
      }
      return true;
    },

    fieldMapping() {
      if (this.field.parent !== undefined && this.field.mappings) {
        const val = this.field.mappings[this.model[this.field.parent]];
        this.$set(this.model, this.field.name, val || '');
      }
      return null;
    },

    computedValidations() {
      let validations = this.field.validations || {};
      if (this.field.type === 'password' && !this.disablePasswordValidation) {
        if (typeof validations === 'string') {
          const rules = validations.split('|').filter(Boolean);
          if (!rules.includes('password_min') && !rules.some(r => r.startsWith('min:'))) {
            rules.push('password_min');
          }
          return rules.join('|');
        }
        if (typeof validations === 'object') {
          if (!validations.password_min && !validations.min) {
            validations = { ...validations, password_min: true };
          }
        }
      }
      return validations;
    },
  },

  methods: {
    updateValue() {
      if (this.field.only_uppercase) {
        this.model[this.field.name] = this.model[this.field.name].toUpperCase();
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/stylesheets/components/form/input_field.scss';
</style>
